import { Component, OnInit, ContentChildren, QueryList, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { FormValidator, ValidationState } from '../services/forms.service';

@Component({
  selector: 'wt-validation-message',
  template: '@if (show) {<div class="help-block"><ng-content></ng-content></div>}',
  imports: [],
})
export class WtValidationMessageComponent {
  @Input() name: string;
  show = false;

  showsErrorIncludedIn(errors: string[]): boolean {
    return errors.some((error) => error === this.name);
  }
}

@Component({
  selector: 'wt-validation-messages',
  template: '<ng-content></ng-content>',
})
export class WtValidationMessagesComponent implements OnInit, OnDestroy {
  @Input() validator: FormValidator;
  @Input() controlName: string;

  @ContentChildren(WtValidationMessageComponent) messageComponents: QueryList<WtValidationMessageComponent>;

  private statusChangesSubscription: Subscription;

  ngOnInit() {
    this.statusChangesSubscription = this.validator.getControlStatus(this.controlName).subscribe((validationState) => {
      if (!this.messageComponents) {
        return;
      }

      this.messageComponents.forEach((messageComponent) => (messageComponent.show = false));

      if (validationState === ValidationState.Error) {
        const firstErrorMessageComponent = this.messageComponents.find((messageComponent) => {
          return messageComponent.showsErrorIncludedIn(Object.keys(this.validator.form.controls[this.controlName].errors ?? {}));
        });

        if (firstErrorMessageComponent) {
          firstErrorMessageComponent.show = true;
        }
      }
    });
  }

  ngOnDestroy() {
    this.statusChangesSubscription.unsubscribe();
  }
}
